// project modules
import { TranslationProvider } from './hooks/TranslationContext';
import AppContext from './AppContext';

export default function App() {
  return (
    <>
      <TranslationProvider>
        <AppContext />
      </TranslationProvider>
    </>
  );
}
